<template>
  <div id="app">
    <loading :loading="isLoading"></loading>
    <router-view />
  </div>
</template>
<script>
import Loading from '@/public/loading'
import { mapState } from 'vuex'
export default {
  components: {
    Loading
  },
  computed: {
    ...mapState({
      isLoading: state => state.loading.isLoading
    })
  },
  mounted () {

  },
  methods: {
  }
}
</script>
<style lang="less">
@import url("./App.less");
#app {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #f8f8f9;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
